import React from 'react'
import { shallow } from 'enzyme'
import { ConfirmDeletePodModal } from '../ConfirmDeletePodModal'
import LoadingButton from '../../common/LoadingButton'

describe('<ConfirmDeletePodModal />', () => {
  let wrapper, props, instance
  beforeEach(() => {
    props = {
      pod: { rid: 1, admins: [] },
      destroyPod() {},
      onCancel() {}
    }
    wrapper = shallow(<ConfirmDeletePodModal {...props} />)
    instance = wrapper.instance()
  })
  describe('#onConfirm', () => {
    it('should call the provided destroyPod prop', () => {
      const destroyPodMock = jest.fn()
      wrapper.setProps({ destroyPod: destroyPodMock })
      wrapper.update()
      instance.onConfirm()
      expect(destroyPodMock).toHaveBeenCalledTimes(1)
    })
    it('should update the component loading state to true', () => {
      wrapper.setState({ loading: false })
      instance.onConfirm()
      expect(wrapper.state('loading')).toBe(true)
    })
  })
  describe('render', () => {
    it('should return something', () => {
      expect(instance.render()).toBeTruthy()
    })
  })
})
